const backdropClass = 'root-modal-backdrop';
const modalClass = 'root-common-modal';
const modalTemplate = `
    <div class="modal-header">
      {{modal-title}}
    </div>
    <div class="modal-body">
      {{modal-body}}
    </div>
    <div class="modal-footer">
      {{modal-buttons}}
    </div>
    `;
var modalService = {
  show: function(content, options) {
    var isDisplayed = false;
    document.getElementsByClassName('root-common-modal').forEach(function(el) {
      var modalHeader = el.getElementsByClassName('modal-header')[0];
      if (modalHeader) {
        var title = modalHeader.textContent.trim();
        if (title && title === content.title) {
          isDisplayed = true;
        }
      }
    });
    if (isDisplayed === true) return;

    let finalModalTemplate = modalTemplate;
    let modalId = Math.random()
      .toString(36)
      .slice(2);

    finalModalTemplate = finalModalTemplate.replace('{{modal-title}}', content.title);
    finalModalTemplate = finalModalTemplate.replace('{{modal-body}}', content.body);
    finalModalTemplate = finalModalTemplate.replace('{{modal-buttons}}', content.buttons);

    var modalEl = document.createElement('div');
    modalEl.setAttribute('data-venue-walkme', 'modal-shown');
    modalEl.classList.add(modalClass);
    modalEl.innerHTML = finalModalTemplate;
    modalEl.dataset.id = modalId;
    document.body.appendChild(modalEl);

    if (options && options.customClass) {
      modalEl.classList.add(options.customClass);
    }

    var backdropEl = document.createElement('div');
    backdropEl.classList.add(backdropClass);
    backdropEl.dataset.id = modalId;
    document.body.appendChild(backdropEl);

    var modal = {
      close: function() {
        var modalEls = document.getElementsByClassName(modalClass);
        modalEls.forEach(function(el) {
          if (el.dataset.id === modalId) {
            el.parentNode.removeChild(el);
          }
        });
        var backdropEls = document.getElementsByClassName(backdropClass);
        backdropEls.forEach(function(el) {
          if (el.dataset.id === modalId) {
            el.parentNode.removeChild(el);
          }
        });
      }
    };
    return modal;
  },
  closeAll: function() {
    var modalEls = document.getElementsByClassName(modalClass);
    modalEls.forEach(function(el) {
      el.parentNode.removeChild(el);
    });

    var backdropEls = document.getElementsByClassName(backdropClass);
    backdropEls.forEach(function(el) {
      el.parentNode.removeChild(el);
    });
  }
};

export { modalService };
